export default "__VITE_ASSET__031309ff__"